import * as React from 'react';
import classnames from 'classnames';

import ActionButton from 'components/buttons/action-button/ActionButton';
import GalleryModalAsset from 'components/gallery-modal/gallery-modal-asset/GalleryModalAsset';

import { __t, applyTranslations } from 'utils/language';

import type { GalleryModalItem } from 'types';

import './deliverable-metrics-gallery-modal-asset.scss';

applyTranslations(require('./deliverable-metrics-gallery-modal-asset.i18n.json'));

type Props = {
  item: GalleryModalItem,
  index: number,
  onUnMatch?: () => void
};

const DeliverableMetricsGalleryModalAsset = ({
  item,
  index,
  onUnMatch
}: Props) => (
  <div className="deliverable-metrics-gallery-modal-asset">
    <GalleryModalAsset
      selectedItem={item}
      currentPosition={index}
    />
    {
      onUnMatch && (
        <div
          className={classnames('deliverable-metrics-gallery-modal-asset__actions', {
            'deliverable-metrics-gallery-modal-asset__actions--visible': !!onUnMatch
          })}
        >
          <ActionButton
            color="primary"
            onClick={onUnMatch}
          >
            {__t('deliverable_metrics_gallery_modal_asset.make_unmatched_label')}
          </ActionButton>
        </div>
      )
    }
  </div>
);

export default DeliverableMetricsGalleryModalAsset;
